/**
 * Returns true if a participant and a connection match
 * @param {object} participant Participant object (from /events/.../participants)
 * @param {object} connection  Connection object (from /events/.../nconnections)
 * @param {object} matchType   Match type eg: {chat: true, ...}
 * @returns boolean
 */

export function isParticipantConnection(participant, connection, matchType = {}) {
    return (
        participant &&
        connection &&
        Object.keys(matchType).reduce((isConnection, type) => isConnection && (!matchType[type] || connection.connection[type]), true)
    );
}
